import React from 'react';
import logoUrl from './Images/logo.jpg';
import { AboutVideo, PaperVideo } from './DefaultVideos';

/** Gives the frame the exact shape of its picture, so the whole picture is shown (never cropped) and the border fits it. */
const fitFrame = (e: React.SyntheticEvent<HTMLImageElement>) => {
  const i = e.currentTarget;
  if (i.naturalWidth && i.naturalHeight) i.parentElement?.style.setProperty('--ar', i.naturalWidth + ' / ' + i.naturalHeight);
};

export interface BannerAds { left?: string; right?: string }
export interface BannerVideo { date: string; urls: string[] }

/**
 * The newspaper logo across the top of pages opened from a shared link (they have no top bar).
 * The page width is shared equally by three parts of the same width and height: left, the logo, right.
 * Each side shows the day's advert picture; a side with no advert shows a default video instead
 * (left: about Royal Journalism, right: today's paper, all pages), on every screen size.
 * ads === undefined means "still finding out", so no video flashes up before the adverts arrive.
 */
export function LogoBanner({ ads, video, page = 2 }: { ads?: BannerAds; video?: BannerVideo | null; page?: number }) {
  const loaded = ads !== undefined;
  const hasAds = !!(ads && (ads.left || ads.right));
  const videos = loaded && !!video;
  if (page === 1 && !hasAds && !videos) return null;
  const logo = <img className="lb-logo" src={logoUrl} alt="Royal Journalism" />;

  if (!hasAds && !videos) {
    return <div className="logo-banner">{logo}</div>;
  }
  const L = ads?.left, R = ads?.right;
  return (
    <div className="logo-banner with-ads">
      <div className="lb-side">{L ? <img src={L} alt="Sponsor" onLoad={fitFrame} /> : videos ? <AboutVideo /> : null}</div>
      <div className="lb-mid">{logo}</div>
      <div className="lb-side">{R ? <img src={R} alt="Sponsor" onLoad={fitFrame} /> : videos && video ? <PaperVideo date={video.date} urls={video.urls} /> : null}</div>
    </div>
  );
}
